import { HOME_LOANS_DASHBOARD_TRIGGER_BLOCKS } from 'src/analytics/blocks/trigger';
import { ZHLPersonalizedNextStepState } from 'src/services/graphql/generated/graphql';
import { SEMANTIC_EVENTS, SEMANTIC_TAGS } from '../../blocks/semantic';
import { createClickstreamEventEnvelope } from '../../utils/createClickstreamEventEnvelope';
import {
    HomeLoansDashboardImpressionEvent,
    HomeLoansDashboardInteractionEvent,
    HomeLoansDashboardViewEvent,
} from '../registeredEvents';
import { NO_STATUS_AVAILABLE } from '../../constants';
import { HomeLoansDashboardClickstreamEvent } from './HomeLoansDashboardClickstreamEvent';
export type HomeLoansDashboardBaseEventProps = {
    lead_id: string;
    journey_stage_cd: ZHLPersonalizedNextStepState | typeof NO_STATUS_AVAILABLE;
    variant_nm?: string;
};
export type HomeLoansDashboardEventProps = {
    trigger_type_nm: string;
    event: HomeLoansDashboardInteractionEvent | HomeLoansDashboardViewEvent | HomeLoansDashboardImpressionEvent;
} & HomeLoansDashboardBaseEventProps;

export const getHomeLoansDashboardEvent = ({
    event,
    lead_id,
    journey_stage_cd,
    trigger_type_nm,
    variant_nm,
}: HomeLoansDashboardEventProps): HomeLoansDashboardClickstreamEvent => ({
    envelope: createClickstreamEventEnvelope(event),
    clickstream_trigger: {
        ...HOME_LOANS_DASHBOARD_TRIGGER_BLOCKS[event],
        trigger_type_nm,
    },
    semantic: {
        semantic_event_nm: SEMANTIC_EVENTS[event],
        topic_tag_txt: SEMANTIC_TAGS[event],
    },
    zhl_discovery: {
        lead_id,
        journey_stage_cd,
        variant_nm,
    },
});
